import { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import {
  LayoutDashboard, UtensilsCrossed, FolderTree, CalendarCheck, Mail, Images, Star, QrCode, Scale, Settings as Cog, LogOut, Menu, ExternalLink,
} from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Primitives";
import { useSeo } from "@/lib/seo";

const NAV = [
  ["/admin", "Genel Bakış", LayoutDashboard, "dashboard", true],
  ["/admin/menu", "Menü Ürünleri", UtensilsCrossed, "menu"],
  ["/admin/kategoriler", "Kategoriler", FolderTree, "categories"],
  ["/admin/rezervasyonlar", "Rezervasyonlar", CalendarCheck, "reservations"],
  ["/admin/mesajlar", "Garson & Mesajlar", Mail, "messages"],
  ["/admin/galeri", "Galeri", Images, "gallery"],
  ["/admin/yorumlar", "Yorumlar", Star, "reviews"],
  ["/admin/qr-menu", "QR Menü", QrCode, "qr"],
  ["/admin/yasal-metinler", "Yasal Metinler", Scale, "legal"],
  ["/admin/ayarlar", "Site Ayarları", Cog, "settings"],
];

function SideNav({ onNavigate }) {
  const { user, logout } = useAuth();
  return (
    <div className="flex h-full flex-col bg-[#140D0B] text-[#FDFBF7]">
      <div className="flex items-center gap-3 px-6 h-20 border-b border-[#D4AF37]/15">
        <Logo size={40} />
        <div>
          <p className="font-display text-sm tracking-[0.12em]">YENİ MERCAN</p>
          <p className="text-[10px] text-[#CBBBAE] tracking-widest uppercase">Yönetim Paneli</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-5 space-y-1">
        {NAV.map(([to, label, Icon, id, end]) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            onClick={onNavigate}
            data-testid={`admin-nav-${id}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors duration-200 ${isActive ? "bg-[#D4AF37] text-[#140D0B] font-semibold" : "text-[#CBBBAE] hover:bg-white/5 hover:text-[#FDFBF7]"}`
            }
          >
            <Icon size={17} /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-[#D4AF37]/15 p-4 space-y-2">
        <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-[#CBBBAE] hover:text-[#D4AF37] px-2" data-testid="admin-view-site-link"><ExternalLink size={14} /> Siteyi görüntüle</Link>
        <p className="text-[11px] text-[#CBBBAE]/70 px-2 truncate" data-testid="admin-user-email">{user?.email}</p>
        <button onClick={logout} className="w-full flex items-center gap-2 rounded-md px-3 py-2 text-sm text-[#E8765E] hover:bg-white/5" data-testid="admin-logout-btn"><LogOut size={16} /> Çıkış Yap</button>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  useSeo({ title: "Yönetim Paneli | Yeni Mercan", path: "/admin", noindex: true });
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="admin-layout">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 no-print"><SideNav /></aside>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="p-0 w-72 border-0">
          <SheetTitle className="sr-only">Menü</SheetTitle>
          <SideNav onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="lg:pl-64">
        <div className="lg:hidden sticky top-0 z-20 flex items-center justify-between h-16 px-4 bg-[#140D0B] text-[#FDFBF7] no-print">
          <button onClick={() => setOpen(true)} aria-label="Menü" data-testid="admin-mobile-menu-btn"><Menu /></button>
          <p className="font-display tracking-[0.12em] text-sm">YENİ MERCAN</p>
          <Logo size={32} />
        </div>
        <main className="p-4 sm:p-8 lg:p-10 max-w-7xl"><Outlet /></main>
      </div>
    </div>
  );
}
